/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Col_AllowedInputs */

const cs_portals_col_allowed = /** @type {(inputs: Portals_Col_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povoleno`)
};

const en_portals_col_allowed = /** @type {(inputs: Portals_Col_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allowed`)
};

/**
* | output |
* | --- |
* | "Allowed" |
*
* @param {Portals_Col_AllowedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_col_allowed = /** @type {((inputs?: Portals_Col_AllowedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Col_AllowedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_col_allowed(inputs)
	return cs_portals_col_allowed(inputs)
});